module.exports = __webpack_public_path__ + "img/nz7.png";